/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import EditActivityChallenge from './edit';
import Waiting from '../../Waiting';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { GetChallengeLibraryById } from '../../../redux/constants/apiConstants';

class EditActivityChallengeMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      challengeDetails: null,
      loading: true,
    };
  }

  getIdFromPath = () => {
    const { history } = this.props;
    const parts = history.location.pathname.split('/');
    return parts[parts.length - 1] || parts[parts.length - 2];
  };

  componentDidMount() {
    this.fetchChallengeDetails();
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.fetchChallengeDetails();
    }
  }

  fetchChallengeDetails = async () => {
    const id = this.getIdFromPath();
    this.setState({ loading: true });
    try {
      const res = await fetchApi(`${GetChallengeLibraryById}/${id}`, 'GET');
      if (res.statusCode === 200) {
        this.setState({ challengeDetails: res.data, loading: false });
      } else {
        toast.error(res.message);
        this.setState({ loading: false });
      }
    } catch(error) {
      toast.error(error.message);
      this.setState({ loading: false });
    }finally{
      this.setState({  loading: false });
    }
  };

  render() {
    const { history, role } = this.props;
    const { challengeDetails, loading } = this.state;
    if (loading || !challengeDetails) {
      return <Waiting />;
    }
    return (
      <EditActivityChallenge
        history={history}
        role={role}
        challengeDetails={challengeDetails}
        challengeId={this.getIdFromPath()}
      />
    );
  }
}

EditActivityChallengeMain.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string,
};

export default withTranslation()(EditActivityChallengeMain);
